<template>
  <div>
    <div class="flex">
      <h5> Selecione o modelo </h5>
    </div>

    <div>
      <a-carousel 
        arrows 
        :dots="false"
        :after-change="changeCarousel"
      >
        <div
          slot="prevArrow"
          class="custom-slick-arrow"
          style="left: 10px;zIndex: 1"
        >
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
          <a-icon type="right-circle" />
        </div>
        <div v-for="(slide, i) in slides" :key="i">
          <component
            :is="slide.componentName"
            :table="table"
            :preview="true"
            :color="qrCode.color"
            :include-logo="includeLogo"
            :ref="`qrCodeComponent_${i}`"
            @downloading="onProgress"
            @downloaded="hasDownloaded"
          />
        </div>
      </a-carousel>
    </div>

    <vs-divider border-style="dashed" class="mt-6 mb-6" />

    <div>
      <h5> Selecione a cor </h5>
      <div class="flex mt-4">
        <twitter
          v-model="qrCode.color"
          :default-colors="defaultColors"
          @input="val => changeColor(val)" />
      </div>
    </div>

    <vs-divider border-style="dashed" class="mt-6 " />

    <!-- <div class="mt-8">
      <h5> Incluir logomarca? </h5>
      <div class="mt-4">
        <vs-radio v-model="includeLogo" :vs-value="1">Sim</vs-radio>
        <vs-radio v-model="includeLogo" :vs-value="0" class="ml-4">Não</vs-radio>
      </div>
    </div> -->
    
    <a-button :disabled="loading" type="danger" height="50px" block size="large" @click="downloadQrCode()">
        GERAR PDF
    </a-button>
  </div>
</template>

<script>
  import { Twitter } from 'vue-color'
  import 'swiper/dist/css/swiper.min.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import QrCodeTemplateOne from './templates/one/Template.vue'
  import QrCodeTemplateTwo from './templates/two/Template.vue'

  export default {
    props: ['table'],
    components: {
      swiper,
      swiperSlide,
      QrCodeTemplateOne,
      QrCodeTemplateTwo,
      Twitter,
    },
    
    data () {
      return {
        includeLogo: 1,
        qrCode: {
          color: '#000000'
        },
        defaultColors: [
          '#000000', '#252422', '#240046', '#023e8a', '#b7094c', '#ff7b00',  '#641220',
          '#343a40', '#403d39', '#5a189a', '#0077b6', '#892b64', '#ffa200',  '#85182a',
          '#979dac', '#ccc5b9', '#D698FF', '#5ED7FF', '#723c70', '#ffdd00 ',  '#b21e35',
          ],
        slides: [
          { preview: true, componentName: 'QrCodeTemplateOne' },
          { preview: true, componentName: 'QrCodeTemplateTwo' },
        ],
        currentSlide: 0,
        loading: false,
      }
    },

    methods: {
      changeColor(color) {
        this.$set(this.qrCode, 'color', color.hex)
      },

      changeCarousel(x) {
        this.currentSlide = x
      },

      onProgress() {
        this.loading = true
      },

      hasDownloaded() {
        this.loading = false
      },

      downloadQrCode() {
        this.loading = true
        const componentName = `qrCodeComponent_${this.currentSlide}`
        console.log(this.$refs[componentName])
        this.$refs[componentName][1].downloadQrCode()
      }
    }
  }
</script>

<style scoped>
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 175px;
  line-height: 160px;
  overflow: hidden;
}

.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: rgb(192, 3, 3);
  background-color: rgba(255, 255, 255, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
  color: rgb(255, 38, 38);
}
</style>